import { Box, Flex } from '@chakra-ui/react';

export const UserLayout = ({ children }: any) => (
  <Flex my={16} width='full' align='center' justifyContent='center'>
    <Box p={8} maxWidth='500px' borderWidth={1} borderRadius={8} boxShadow='lg'>
      {children}
    </Box>
  </Flex>
);
